const isCi = process.env.CI === "true";

const parsePipelineToken = () => {
  try {
    const rawToken = process.env.NEXT_PUBLIC_SSR_BACKEND_TOKEN;
    if (!rawToken) {
      return null;
    }
    const parsedToken = JSON.parse(`${rawToken}`);
    if (parsedToken && typeof parsedToken === "object") {
      return parsedToken;
    }
  } catch (error) {
    // noop: token ausente o malformado
  }
  return null;
};

const shouldAttachAuthHeader = ({ build = false, envName = "" }) => {
  const normalizedEnv = `${envName}`.toLowerCase();
  return Boolean(build) && normalizedEnv !== "local" && normalizedEnv !== "prod";
};

export const getRecommendatorAuthHeaders = async ({ context, build = false }) => {
  if (typeof window !== "undefined") {
    return {};
  }

  const envName = context?.environment?.name || "";

  if (!shouldAttachAuthHeader({ build, envName })) {
    return {};
  }

  const pipelineToken = parsePipelineToken();

  if (isCi && pipelineToken) {
    return pipelineToken;
  }

  try {
    const runtimeRequire = eval("require");
    const { getJWTCloudRun } = runtimeRequire("@gc-npm/node.ssr-process.google-auth");
    const runtimeToken = await getJWTCloudRun("ssr-backend");
    if (runtimeToken && typeof runtimeToken === "object") {
      return runtimeToken;
    }
  } catch (error) {
    // fallback al token de pipeline si existe
  }

  return pipelineToken || {};
};

export default getRecommendatorAuthHeaders;
